import { render, staticRenderFns } from "./CustomerListItem.vue?vue&type=template&id=0c8dd4a2&scoped=true&"
import script from "./CustomerListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListItem.vue?vue&type=style&index=0&id=0c8dd4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8dd4a2",
  null
  
)

export default component.exports